module.exports = {
  ownerId: '11111111111111111111111111111111',
  contractId: 'GWRSAVFMjXx8HpQFaNJMqBV7MBgMK4br5UESsB4S31Ec',
  dashTldDocumentId: '6Zft8WEaEPzfbSVMsd6xCw3KgCqAQEneupSB9wx2EhJ',
};
